import React, { lazy } from "react";
import { Routes, Route } from "react-router-dom";

const NotFound = lazy(() => import("../../container/pages/404"));

const MembersReport = lazy(() =>
  import("../../container/reports/MembersReports")
);
const SubscriptionReports = lazy(() =>
  import("../../container/reports/SubscriptionReports")
);
const VATReports = lazy(() => import("../../container/reports/PaymentReports"));

function IconsRoute() {
  return (
    <Routes>
      <Route path="/members" element={<MembersReport />} />
      <Route path="/subscriptions" element={<SubscriptionReports />} />
      <Route path="/payments" element={<VATReports />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default IconsRoute;
